import { createApiRef } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { Score } from '../schema/openapi';

export const scorecardApiRef = createApiRef<ScorecardApi>({
  id: 'plugin.scorecard',
});

export interface ScorecardApi {
  getScores(entity: Entity): Promise<Score[]>;
}
